import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import TextArea from 'component/utils/TextArea'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'

class VideosUpdateContent extends Component {
  constructor(props) {
    super(props)

    const { initialValues } = this.props

    this.state = {
      dtStartFocused: false,
      dtEndFocused: false,
      dtStart: moment(initialValues.startDate),
      dtEnd: moment(initialValues.endDate),
    }
  }

  handleChangeStartDate = (event) => {
    const { setValueToField } = this.props

    this.setState({ dtStart: event })
    setValueToField('dtStart', event)
  }

  handleChangeEndDate = (event) => {
    const { setValueToField } = this.props

    this.setState({ dtEnd: event })
    setValueToField('dtEnd', event)
  }

  isOutsideRange() {
    return false
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { initialValues, values, onSubmit } = this.props

    const data = {
      ...values,
      dtStart: moment(values.dtStart).format('DD/MM/YYYY'),
      dtEnd: moment(values.dtEnd).format('DD/MM/YYYY'),
      idVideo: initialValues.videoId,
    }

    onSubmit(data)
  }

  handleViewModal = () => {
    const { viewModal, initialValues, values } = this.props

    const data = {
      ...initialValues,
      ...values,
      videoTitle: values.nmVideo,
      videoDescription: values.dsVideo,
      startDate: values.dtStart,
      endDate: values.dtEnd,
      idVideo: initialValues.videoId,
    }

    viewModal(data)
  }

  render() {
    const { translate, fields, closeModal } = this.props

    const { dtStartFocused, dtEndFocused } = this.state

    return (
      <section>
        <form className='VideoEditForm'>
          <Row>
            <Col xs={12}>
              <legend className='margin-top margin-bottom'>
                {translate('mobile-update.update')}
              </legend>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...fields.nmVideo}
                error={translate(fields.nmVideo.error)}
              >
                <Input
                  {...fields.nmVideo.input}
                  id='nmVideoEdit'
                  maxLength={40}
                  label={translate('videos.nmVideo')}
                />
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...fields.dsVideo}
                error={translate(fields.dsVideo.error)}
              >
                <TextArea
                  type='textarea'
                  id='dsVideoEdit'
                  {...fields.dsVideo.input}
                  rows={4}
                  maxLength={150}
                  label={translate('videos.dsVideo')}
                  autoExpandable
                />
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <span className='gray-label'>{translate('videos.period')}</span>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <Field
                {...fields.dtStart}
                error={translate(fields.dtStart.error)}
                glyph='glyph glyph-calendar'
              >
                <SingleDatePicker
                  date={this.state.dtStart}
                  onDateChange={this.handleChangeStartDate}
                  focused={dtStartFocused}
                  onFocusChange={({ focused }) =>
                    this.setState({ dtStartFocused: focused })
                  }
                  placeholder={translate('videos.dtStart')}
                  displayFormat='DD/MM/YYYY'
                  isOutsideRange={this.isOutsideRange}
                />
              </Field>
            </Col>

            <Col xs={12} md={6}>
              <Field
                {...fields.dtEnd}
                error={translate(fields.dtEnd.error)}
                glyph='glyph glyph-calendar'
              >
                <SingleDatePicker
                  date={this.state.dtEnd}
                  onDateChange={this.handleChangeEndDate}
                  focused={dtEndFocused}
                  onFocusChange={({ focused }) =>
                    this.setState({ dtEndFocused: focused })
                  }
                  placeholder={translate('videos.dtEnd')}
                  displayFormat='DD/MM/YYYY'
                  isOutsideRange={this.isOutsideRange}
                />
              </Field>
            </Col>
          </Row>

          <Row className='margin-top-double margin-bottom'>
            <Col xs={6} md={6}>
              <button
                role='button'
                type='button'
                onClick={closeModal}
                className='button-hollow button-hollow-danger button-full align-center'
              >
                {translate('cancel_button_label')}
              </button>
            </Col>

            <Col xs={6} md={6}>
              <button
                role='button'
                type='button'
                onClick={this.handleViewModal}
                className='button button-primary button-full'
              >
                {translate('videos.view')}
              </button>
            </Col>
          </Row>

          <Row className='margin-bottom'>
            <Col xs={12} md={12}>
              <button
                role='button'
                onClick={this.handleSubmit}
                className='button button-primary button-full align-center'
              >
                {translate('save_button_label')}
              </button>
            </Col>
          </Row>
        </form>
      </section>
    )
  }
}

VideosUpdateContent.propTypes = {
  translate: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  viewModal: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
}

const fields = ['dsVideo', 'nmVideo', 'dtStart', 'dtEnd']

export default Form({ fields })(VideosUpdateContent)

export { VideosUpdateContent }
